import { render, staticRenderFns } from "./ideaList.vue?vue&type=template&id=376aa38c&scoped=true&"
import script from "./ideaList.vue?vue&type=script&lang=js&"
export * from "./ideaList.vue?vue&type=script&lang=js&"
import style0 from "./ideaList.vue?vue&type=style&index=0&id=376aa38c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376aa38c",
  null
  
)

export default component.exports